import { merge } from 'cerebral/operators';
import { state, props } from 'cerebral/tags';

import answerSet from './answerSet';

export default [
    merge(state`app.answers.${props`part`}.${props`section`}`, props`answer`),
    ...answerSet,
];



// WEBPACK FOOTER //
// ./src/store/modules/app/signals/mergeAnswer.js